import { useState } from "react";
import { motion } from "framer-motion";
import { Plus, Minus } from "lucide-react";
import { Reveal } from "../components/Reveal";
import { FAQS } from "../data/content";

export default function FaqSection() {
  const [openFaq, setOpenFaq] = useState(0);

  return (
    <section className="max-w-[1400px] mx-auto px-6 md:px-10 pb-24 md:pb-36">
      <div className="grid md:grid-cols-12 gap-x-10 gap-y-8">
        <div className="md:col-span-4">
          <Reveal>
            <h2 className="font-display text-4xl md:text-5xl tracking-tighter font-medium leading-[0.98]">
              Questions,<br />answered.
            </h2>
          </Reveal>
        </div>
        <div className="md:col-span-8 border-t border-black/10">
          {FAQS.map((item, i) => {
            const isOpen = openFaq === i;
            return (
              <Reveal key={i} delay={i * 0.04}>
                <div className="border-b border-black/10">
                  <button
                    onClick={() => setOpenFaq(isOpen ? -1 : i)}
                    className="w-full flex items-center justify-between gap-6 py-6 md:py-7 text-left group"
                    data-testid={`faq-toggle-${i}`}
                  >
                    <span className={`font-display text-xl md:text-2xl tracking-tight font-medium transition-colors duration-300 ${isOpen ? "text-black" : "text-neutral-700 group-hover:text-black"}`}>
                      {item.q}
                    </span>
                    <span className={`shrink-0 flex h-9 w-9 items-center justify-center rounded-full border transition-all duration-300 ${isOpen ? "bg-[#0a0a0a] text-white border-black rotate-0" : "border-black/15 text-black group-hover:border-black"}`}>
                      {isOpen ? <Minus size={18} /> : <Plus size={18} />}
                    </span>
                  </button>
                  <motion.div initial={false} animate={{ height: isOpen ? "auto" : 0, opacity: isOpen ? 1 : 0 }} transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }} className="overflow-hidden">
                    <p className="pb-7 text-lg text-neutral-500 leading-relaxed max-w-2xl">{item.a}</p>
                  </motion.div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
